import { Flex, Text } from 'roo-ui/components';

const Item = ({ labelItem, valueItem, boldValue = false }) => (
  <Flex flex="1 1 50%" flexDirection="column">
    <Text>{labelItem}</Text>
    <Text fontSize="lg" fontWeight={boldValue ? 'bold' : 'normal'}>
      {valueItem}
    </Text>
  </Flex>
);

export default Item;
